module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/48366697aa58756d9140e57957188c09.png";